<template>
  <div class="customer-detail">
    <div class="customer-header pt-0">
      <slot name="header"></slot>
      <div class="text-xs-right">
        <v-btn
          v-if="$store.state.userid == 'zwizadmin' || $store.state.userid.includes('zwiz')"
          v-clipboard:copy="user.id"
          v-clipboard:success="handleCopyUserId"
          v-clipboard:error="handleErrorCopyUserId"
          fab
          color="primary"
          depressed
          small
          class="extra-small"
          style="position: absolute; right: 0; top: 0"
        >
          <v-icon>file_copy</v-icon>
        </v-btn>
      </div>
      <div class="text-xs-center">
        <v-avatar size="100">
          <v-img
            :lazy-src="user.profile_pic"
            :src="user.profile_pic ? user.profile_pic : '/static/img/assets/livechat/profile.png'"
            aspect-ratio="1"
            class="grey lighten-2"
          >
            <template #placeholder>
              <v-layout fill-height align-center justify-center ma-0>
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-layout>
            </template>
          </v-img>
        </v-avatar>
        <div class="text-xs-center mt-2" style="color: white">
          <div class="text-xs-center mt-2 px-5" style="color: white">
            <edit-customer-value
              v-model="userRealname"
              :dark="true"
              :userid="user.id"
              :placeholder="$t('Name')"
              @onEdit="putuserrealname('realname', $event)"
            >
              <customer-item-value :value="userRealname">{{ userRealname }}</customer-item-value>
            </edit-customer-value>
          </div>
          <div v-if="user.realname">({{ user.first_name }} {{ user.last_name }})</div>
        </div>

        <div class="mb-4 text-xs-center">
          <div>
            <v-btn
              v-if="$route.name != 'allinonechat' && $route.name != 'livechat'"
              target="_blank"
              small
              depressed
              round
              color="blue-grey"
              dark
              @click.stop="goToLivechat(user, user.app)"
            >
              <em class="fas fa-comments mr-1" />
              {{ $t('View all-in-one chat') }}
            </v-btn>
          </div>

          <template
            v-if="
              selectedBot.unlock_open_bill == true ||
              $store.state.nestlePages.some((page) => page.pageid == selectedBot.pageid)
            "
          >
            <v-btn :href="shoplink" target="_blank" small depressed round outline dark>
              <v-icon class="mr-1" small>shopping_cart</v-icon>
              เปิดบิล
            </v-btn>
          </template>
          <template
            v-else-if="
              (['nvbb', 'ecommercebasic', 'cityfresh', 'tcp', 'ticket_v3'].includes(
                selectedBot.theme
              ) ||
                (['ticket', 'summitcapital'].includes(selectedBot.theme) &&
                  $store.state.nestlePages.some((page) => page.pageid == selectedBot.pageid))) &&
              shoplink
            "
          >
            <v-btn :href="shoplink" target="_blank" small depressed round outline dark>
              <v-icon class="mr-1" small>shopping_cart</v-icon>
              {{ $t('Create order') }}
            </v-btn>
          </template>
          <template v-if="selectedBot.theme == 'nvbb'">
            <v-btn
              :href="`https://shopcommu.zwiz.app/nvbbdrink/${
                $route.name == 'allinonechat' ? $store.state.livechat.pageid : selectedBot.pageid
              }/?userid=${user.id}&sessiontoken=${
                user.sessiontoken
              }&lang=${currentLang}&app=line&from=livechat`"
              target="_blank"
              small
              depressed
              round
              outline
              dark
              >แจ้งรับ</v-btn
            >
          </template>
        </div>
      </div>
    </div>
    <template v-if="!loading">
      <div
        :class="{
          'dark-style': ['cityfresh'].includes($store.state.livechat.theme)
        }"
      >
        <div v-if="selectedBot.theme == 'sahapan'" class="text-xs-right">
          <sahapan-add-manual :user="user"></sahapan-add-manual>
        </div>
        <v-layout wrap>
          <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>{{ $t('Channel') }}</label>
            <p>
              <ChannelLabel :channel="user.app">
                <template #channel="{ channelColor, selectedChannel }">
                  <span v-if="selectedChannel" :style="{ color: channelColor }">
                    <em v-if="selectedChannel.icon" :class="selectedChannel.icon" />
                  </span>
                </template>
              </ChannelLabel>
            </p>
          </v-flex>

          <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>{{ $t('gender') }}</label>
            <!-- <p>{{ $t(user.gender) || $t(json_variable.gender) }}</p> -->
            <edit-customer-value
              v-if="selectedBot.theme === 'nvbb'"
              v-model="user['gender']"
              :userid="user.id"
              :placeholder="$t('gender')"
              :type="'gender'"
              :options="[
                {
                  label: $t('Male'),
                  value: 'male'
                },
                {
                  label: $t('Female'),
                  value: 'female'
                },
                {
                  label: $t('no gender'),
                  value: ''
                }
              ]"
              @onEdit="putusergender('gender', $event)"
            >
              <customer-item-value :value="user['gender']">{{
                $t(`${user.gender}`)
              }}</customer-item-value>
            </edit-customer-value>
            <p v-else>{{ $t(`${user.gender || '-'}`) }}</p>
          </v-flex>

          <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>{{ $t('Locale') }}</label>
            <p>
              <template v-if="userLocale">
                <flag :iso="userLocale.icon" />
                {{ userLocale.title }}
              </template>
              <template v-else>-</template>
            </p>
          </v-flex>

          <v-flex xs12 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption">
              {{ $t('Status') }}
              <v-premium-lock :inline="true"></v-premium-lock>
            </label>
            <div>
              <p>
                <edit-customer-value
                  v-if="selectedBot.theme == 'centralhr'"
                  v-model="user['status']"
                  :userid="user.id"
                  :placeholder="$t('Status')"
                  :type="'dropdown'"
                  :options="['Resign', 'Rehire']"
                  @onEdit="onEditStatus"
                >
                  <customer-item-value :value="user['status']">{{
                    user.status
                  }}</customer-item-value>
                </edit-customer-value>
                <edit-customer-value
                  v-else
                  v-model="user['status']"
                  :userid="user.id"
                  :placeholder="$t('Status')"
                  :item-option="statusOptions"
                  :multiple="false"
                  :combobox="true"
                  @onEdit="onEditStatus"
                  @onSearch="onSearchStatus"
                >
                  <customer-item-value :value="user['status']">{{
                    user.status
                  }}</customer-item-value>
                </edit-customer-value>
              </p>
            </div>
          </v-flex>
          <template v-if="selectedBot.theme == 'scgdistribution'">
            <v-flex xs6 class="px-3 py-2">
              <div>
                <label class="caption" for>{{ $t('Shop code') }}</label>

                <p>
                  <edit-customer-value
                    v-model="user['cardnumber']"
                    :userid="user.id"
                    :type="'number'"
                    :placeholder="$t('Card number')"
                    @onEdit="putusercardnumber('cardnumber', $event)"
                  >
                    <customer-item-value :value="user['cardnumber']">{{
                      user.cardnumber
                    }}</customer-item-value>
                  </edit-customer-value>
                </p>
              </div>
            </v-flex>
            <v-flex xs6 class="px-3 py-2">
              <div>
                <label class="caption" for>{{ $t('Shop name') }}</label>
                <p>
                  <edit-customer-value
                    v-model="user['realname']"
                    :userid="user.id"
                    :placeholder="$t('Name')"
                    @onEdit="putuserrealname('realname', $event)"
                  >
                    <customer-item-value :value="user['realname']">{{
                      user.realname
                    }}</customer-item-value>
                  </edit-customer-value>
                </p>
              </div>
            </v-flex>
          </template>
          <v-flex xs12 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption">
              {{ $t('Address') }}
              <v-premium-lock :inline="true"></v-premium-lock>
            </label>
            <div>
              <p>
                <edit-customer-value
                  v-model="user['address']"
                  :userid="user.id"
                  :placeholder="$t('Address')"
                  type="textarea"
                  @onEdit="onEditAddress"
                >
                  <customer-item-value :value="user['address']">{{
                    user.address
                  }}</customer-item-value>
                </edit-customer-value>
              </p>
            </div>
          </v-flex>
          <v-flex v-if="json_variable.age" xs6 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>{{ $t('age') }}</label>
            <p>{{ json_variable.age }}</p>
          </v-flex>
          <v-flex v-if="json_variable.job" xs6 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>{{ $t('job') }}</label>
            <p>{{ json_variable.job }}</p>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout wrap>
          <v-flex v-if="selectedBot.type == 'nextcapital'" xs6 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption">
              {{ $t('next_capital_register_date') }}
              <v-premium-lock :inline="true"></v-premium-lock>
            </label>
            <div>
              <p>
                {{ user.login_timestamp ? getFormatDate(user.login_timestamp, 'DD/MM/YYYY') : '-' }}
              </p>
            </div>
          </v-flex>
          <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>{{ $t('Register Date') }}</label>
            <p>
              {{
                user.registertimestamp ? getFormatDate(user.registertimestamp, 'DD/MM/YYYY') : '-'
              }}
            </p>
          </v-flex>
          <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>{{ $t('Last Active Date') }}</label>
            <p>{{ user.timestamp ? getFormatDate(user.timestamp, 'DD/MM/YYYY') : '-' }}</p>
          </v-flex>

          <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>{{ $t('Email') }}</label>
            <p v-if="selectedBot.theme != 'toacrm'">
              <edit-customer-value
                v-model="user['email']"
                :userid="user.id"
                :placeholder="$t('Email')"
                @onEdit="onEditEmail"
              >
                <customer-item-value :value="user['email']">{{ user.email }}</customer-item-value>
              </edit-customer-value>
            </p>
            <p v-else>
              {{ toacrmUser.email }}
            </p>
          </v-flex>

          <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>{{ $t('phone no.') }}</label>
            <p v-if="selectedBot.theme != 'toacrm'">
              <edit-customer-value
                v-model="user['phoneno']"
                type="number"
                :userid="user.id"
                :placeholder="$t('phone no.')"
                @onEdit="onEditPhone"
              >
                <customer-item-value :value="user['phoneno']">{{
                  user.phoneno
                }}</customer-item-value>
              </edit-customer-value>
            </p>
            <p v-else>
              {{ toacrmUser.phone }}
            </p>
          </v-flex>

          <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>{{ $t('Context') }}</label>
            <p>
              <template v-if="ableToEditCustomer">
                <edit-customer-value
                  v-model="user['context']"
                  :userid="user.id"
                  :placeholder="$t('Context')"
                  @onEdit="onEditContext"
                >
                  <customer-item-value :value="user['context']">{{
                    user.context
                  }}</customer-item-value>
                </edit-customer-value>
              </template>
              <template v-else>
                {{ user.context || '-' }}
              </template>
            </p>
          </v-flex>
          <v-flex v-if="['cityfresh'].includes(selectedBot.theme)" xs6 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>{{ $t('total_amount_paid') }}</label>
            <p>
              <span class="primary-color">฿{{ userTotalAmountPaid | decimalFormat }}</span>
            </p>
          </v-flex>

          <v-flex
            v-if="['generalixwarroom', 'generali'].includes(selectedBot.theme)"
            xs6
            class="pl-3 pr-3 pt-2 pb-2"
          >
            <label class="caption">
              {{ $t('Block User') }}
            </label>
            <p>
              <template v-if="user.roomid == 'blocked'">
                <v-btn color="error" outline small depressed @click="handleBlockUser('unblocked')">
                  <v-icon class="mr-1"> clear </v-icon>
                  {{ $t('Unblock') }}
                </v-btn>
              </template>
              <template v-else>
                <v-btn color="error" small depressed @click="handleBlockUser('blocked')">
                  <v-icon class="mr-1">block</v-icon>
                  {{ $t('Block') }}
                </v-btn>
              </template>
            </p>
          </v-flex>

          <v-flex v-if="selectedBot.theme == 'ustore'" xs6 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>{{ $t('ชื่อ สกุล') }}</label>
            <p>
              <edit-customer-value
                v-model="user['customrealname']"
                :userid="user.id"
                placeholder="ชื่อ สกุล"
                @onEdit="onEditCustomRealname"
              >
                <customer-item-value :value="user['customrealname']">{{
                  user.customrealname
                }}</customer-item-value>
              </edit-customer-value>
            </p>
          </v-flex>

          <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>Note</label>
            <p>
              <edit-customer-value
                v-model="user['temp_msg']"
                :userid="user.id"
                :type="'textarea'"
                placeholder="Note"
                @onEdit="onEditNote"
              >
                <customer-item-value style="white-space: pre-wrap" :value="user['temp_msg']">{{
                  user.temp_msg
                }}</customer-item-value>
              </edit-customer-value>
            </p>
          </v-flex>

          <v-flex v-if="isBU" xs6 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>{{ $t('Line ID') }}</label>
            <p>
              <edit-customer-value
                v-model="user['lineid']"
                :userid="user.id"
                :placeholder="$t('Line ID')"
                @onEdit="onEditLineId"
              >
                <customer-item-value :value="user['lineid']">{{ user.lineid }}</customer-item-value>
              </edit-customer-value>
            </p>
          </v-flex>

          <v-flex v-if="isBU" xs6 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>{{ $t('School') }}</label>
            <p>
              <edit-customer-school
                v-model="user['school']"
                :userid="user.id"
                :placeholder="$t('School')"
                @onEdit="onEditSchool"
              >
                <customer-item-value :value="user['school']">{{ user.school }}</customer-item-value>
              </edit-customer-school>
            </p>
          </v-flex>

          <v-flex v-if="isBU" xs6 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>{{ $t('Province') }}</label>
            <p>
              <edit-customer-value
                v-model="user['province']"
                :userid="user.id"
                :placeholder="$t('Province')"
                @onEdit="onEditProvince"
              >
                <customer-item-value :value="user['province']">{{
                  user.province
                }}</customer-item-value>
              </edit-customer-value>
            </p>
          </v-flex>
        </v-layout>

        <v-layout v-if="selectedBot.theme == 'sahapan'" wrap>
          <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>{{ $t('Real First Name') }}</label>
            <p>
              <edit-customer-value
                v-model="user['realfirstname']"
                :userid="user.id"
                :placeholder="$t('Real First Name')"
                @onEdit="saveSahapanUserProfile('realfirstname', $event)"
              >
                <customer-item-value :value="user['realfirstname']">{{
                  user.realfirstname
                }}</customer-item-value>
              </edit-customer-value>
            </p>
          </v-flex>
          <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>{{ $t('Real Last Name') }}</label>
            <p>
              <edit-customer-value
                v-model="user['reallastname']"
                :userid="user.id"
                :placeholder="$t('Real Last Name')"
                @onEdit="saveSahapanUserProfile('reallastname', $event)"
              >
                <customer-item-value :value="user['reallastname']">{{
                  user.reallastname
                }}</customer-item-value>
              </edit-customer-value>
            </p>
          </v-flex>
          <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>{{ $t('Date of Birth') }}</label>
            <p>
              <edit-customer-value
                v-model="user['dob']"
                :userid="user.id"
                :placeholder="$t('Date of Birth')"
                type="date"
                @onEdit="saveSahapanUserProfile('dob', $event)"
              >
                <customer-item-value :value="user['dob']">
                  <template v-if="user.dob">{{ user.dob | DateFormat('DD/MM/YYYY') }}</template>
                  <template v-else>-</template>
                </customer-item-value>
              </edit-customer-value>
            </p>
          </v-flex>
          <v-flex xs12 sm12 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>{{ $t('Address') }}</label>
            <p>
              <edit-customer-value
                v-model="user['address']"
                :userid="user.id"
                type="textarea"
                :placeholder="$t('Address')"
                @onEdit="saveSahapanUserProfile('address', $event)"
              >
                <customer-item-value :value="user['address']">{{
                  user.address
                }}</customer-item-value>
              </edit-customer-value>
            </p>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <div class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>
            {{ $t('Tag') }}
            <v-premium-lock :inline="true"></v-premium-lock>
          </label>

          <template v-if="!['tcp-broadcast'].includes(selectedBot.type)">
            <a
              v-if="$store.getters.getPackage == 'premium' && !isEditTag && !isCoachlab"
              href="javascript:void(0);"
              @click="editTag"
            >
              <em class="fa fa-pencil-alt middle" />
            </a>
          </template>
        </div>
        <div class="pl-3 pr-3 pt-2 pb-2">
          <template v-if="!isEditTag">
            <div v-if="tags.length == 0" class="text-xs-left">{{ $t('No tag') }}</div>
            <ul class="tags">
              <li v-for="(tag, index) in tags" :key="'usertag_' + index" class="tag">
                <specialtext :text="tag"></specialtext>
              </li>
            </ul>
          </template>
          <template v-else>
            <tags
              v-model="usertag"
              :tags="usertags"
              style="margin-bottom: 5px"
              :btn-text="$t('Add tag')"
              :item-option="tagOptions"
              :combobox="true"
              @tags-changed="addUserTags"
              @before-adding-tag="checkUserTags"
              @onSearch="onSearchTag"
            ></tags>

            <div class="text-xs-center" style="margin-top: 15px">
              <v-btn outline color="grey" small @click="cancelEditTag">{{ $t('cancel') }}</v-btn>
              <v-btn depressed color="primary" small @click="saveEditTag">{{ $t('Save') }}</v-btn>
            </div>
          </template>
        </div>

        <v-divider></v-divider>
        <div v-if="userSession" class="pl-3 pr-3 pt-2 pb-2">
          <div class="mb-2">
            <label class="caption">
              {{ $t('Data Summary') }}
            </label>
            <a v-if="!isEditSession" href="javascript:void(0);" @click="isEditSession = true">
              <em class="fa fa-pencil-alt middle" />
            </a>
          </div>

          <div
            v-if="typeof userSession === 'object'"
            style="
              overflow-y: auto;
              max-height: 300px;
              padding: 5px;
              background: #f7f7f7;
              border: 1px solid #eee;
              border-radius: 5px;
            "
          >
            <div
              v-for="(value, name, index) in userSession"
              :key="`key${index}`"
              style="padding: 10px; margin: 5px 0; border: 1px solid #eee; background: white"
            >
              <v-btn v-if="isEditSession" icon style="float: right" @click="deleteSession(name)"
                ><v-icon color="primary">delete</v-icon></v-btn
              >
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <template>
                    <span style="color: #ff706b">{{ name }}</span></template
                  ></v-flex
                >
                <v-flex xs12 sm6 class="form-control">
                  <template v-if="!isEditSession">{{ value }}</template>
                  <input v-else v-model="userSession[name]" type="text"
                /></v-flex>
              </v-layout>
            </div>
          </div>
          <div v-else>
            <p>{{ userSession }}</p>
          </div>
          <div v-if="isEditSession" class="text-xs-center mt-2">
            <v-btn outline color="grey" small @click="cancleEditSession">{{ $t('cancel') }}</v-btn>
            <v-btn depressed color="primary" small @click="editSession">{{ $t('Save') }}</v-btn>
          </div>
        </div>
        <v-divider v-if="userSession"></v-divider>

        <div v-if="['veranda_new', 'verso'].includes(selectedBot.theme)">
          <v-divider></v-divider>

          <div class="px-3 pt-3">
            <p class="mb-2">ประวัติการทำแบบประเมิน</p>
            <v-data-table
              hide-actions
              :loading="loading"
              :headers="headers"
              :items="satisfactionHistory"
              :pagination.sync="pagination"
              class="elevation-1 mt-3"
            >
              <template #items="props">
                <tr>
                  <td>{{ props.item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}</td>
                  <td>{{ props.item.satisfaction_score || '-' }}</td>
                  <td>{{ props.item.feedback || '-' }}</td>
                </tr>
              </template>
            </v-data-table>
            <div class="mt-2">
              <v-pagination
                v-model="pageNumber"
                :total-visible="6"
                :length="pageLength"
                @input="handleChangePage"
              ></v-pagination>
            </div>
          </div>
        </div>
      </div>
    </template>
    <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
      >{{ $t('Link Copied') }}!</v-snackbar
    >
  </div>
</template>

<script>
import CustomerDetail from './CustomerDetail.js'

export default {
  mixins: [CustomerDetail]
}
</script>

<style lang="scss" scoped>
.dark-style {
  .caption {
    color: #000 !important;
  }
  p {
    color: #000 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customer/CustomerDetail.vue